import produce from 'immer';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED, UPDATE_RSS_SETTING } from 'ContentEditorUI/redux/actions/actionTypes';
import mergeWith from 'hs-lodash/mergeWith';
import set from 'hs-lodash/set';
const defaultState = {
  rssEmailEntryTemplateEnabled: false,
  rssUrl: '',
  maxRssEntries: 0,
  rssEmailImageMaxWidth: 0,
  rssEmailBlogImageMaxWidth: 0,
  rssEmailEntryTemplate: '',
  rssEmailByText: '',
  rssEmailClickThroughText: '',
  rssEmailCommentText: '',
  rssEmailAuthorLineTemplate: '',
  rssToEmailTiming: {},
  blogRssSettings: {},
  rssEmailByTextDefault: '',
  rssEmailEntryLayoutDefault: '',
  rssEmailEntryTemplateDefault: ''
};
export const rssSettingsReducer = (state = defaultState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case FETCH_CONTENT_SCHEMA_SUCCEEDED:
        {
          const {
            content,
            context
          } = action.response;
          draft = Object.assign({}, draft, defaultState);
          mergeWith(draft, {
            rssEmailEntryTemplateEnabled: content.rssEmailEntryTemplateEnabled,
            rssUrl: content.rssUrl,
            maxRssEntries: content.maxRssEntries,
            rssEmailImageMaxWidth: content.rssEmailImageMaxWidth,
            rssEmailEntryTemplate: content.rssEmailEntryTemplate,
            rssEmailByText: content.rssEmailByText,
            rssEmailClickThroughText: content.rssEmailClickThroughText,
            rssEmailCommentText: content.rssEmailCommentText,
            rssEmailAuthorLineTemplate: content.rssEmailAuthorLineTemplate,
            rssEmailBlogImageMaxWidth: content.rssEmailBlogImageMaxWidth,
            rssEmailByTextDefault: context && context.rss_email_by_text_default,
            rssEmailEntryLayoutDefault: context && context.rss_email_entry_layout_default,
            rssEmailEntryTemplateDefault: context && context.rss_email_entry_template_default,
            blogRssSettings: content.blogRssSettings,
            rssToEmailTiming: content.rssToEmailTiming
          }, (oldVal, newVal) => typeof newVal !== 'undefined' && newVal !== null ? newVal : oldVal);
          return draft;
        }
      case UPDATE_RSS_SETTING:
        {
          const {
            updatedProperties
          } = action;
          for (const i of Object.keys(updatedProperties)) {
            const path = i.split('-');
            set(draft, path, updatedProperties[i]);
          }
          return draft;
        }
      default:
        return draft;
    }
  });
};
export default rssSettingsReducer;